"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    settings: {
        path: "/settings",
    },
    records: {
        path: "/settings/account/records",
    },
    submissionsBuilder: {
        path: "/settings/account/records/submissions-builder/:submissionTypeId?",
    },
    propertyData: {
        path: "/settings/account/property-data",
    },
    editSection: {
        path: "/settings/account/property-data/section/:sectionId",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0dGluZ3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9yb3V0aW5nL3NldHRpbmdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFzQztBQUV6QixRQUFBLE1BQU0sR0FBRyxJQUFBLG1CQUFXLEVBQUM7SUFDaEMsUUFBUSxFQUFFO1FBQ1IsSUFBSSxFQUFFLFdBQVc7S0FDbEI7SUFDRCxPQUFPLEVBQUU7UUFDUCxJQUFJLEVBQUUsMkJBQTJCO0tBQ2xDO0lBQ0Qsa0JBQWtCLEVBQUU7UUFDbEIsSUFBSSxFQUFFLGtFQUFrRTtLQUN6RTtJQUNELFlBQVksRUFBRTtRQUNaLElBQUksRUFBRSxpQ0FBaUM7S0FDeEM7SUFDRCxXQUFXLEVBQUU7UUFDWCxJQUFJLEVBQUUsb0RBQW9EO0tBQzNEO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBzZXR0aW5nczoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzXCIsXG4gIH0sXG4gIHJlY29yZHM6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9hY2NvdW50L3JlY29yZHNcIixcbiAgfSxcbiAgc3VibWlzc2lvbnNCdWlsZGVyOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvYWNjb3VudC9yZWNvcmRzL3N1Ym1pc3Npb25zLWJ1aWxkZXIvOnN1Ym1pc3Npb25UeXBlSWQ/XCIsXG4gIH0sXG4gIHByb3BlcnR5RGF0YToge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2FjY291bnQvcHJvcGVydHktZGF0YVwiLFxuICB9LFxuICBlZGl0U2VjdGlvbjoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2FjY291bnQvcHJvcGVydHktZGF0YS9zZWN0aW9uLzpzZWN0aW9uSWRcIixcbiAgfSxcbn0pO1xuIl19